import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Objects, Parts, Types} from "components/index";
import GoogleMapReact from "google-map-react";
import API from "@beardeddevops/react.api";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Select from "react-select";
import Person from "@material-ui/icons/Person"
import {Circle} from '@react-google-maps/api'
import {Polygon} from '@react-google-maps/api'
import {Button} from "reactstrap";
import moment from "moment";
import {isEmptyObject} from "jquery";
import Paper from "@material-ui/core/Paper";
import {Slider} from "@material-ui/core";
import UserRoles from "../../constants/UserRoles";
import {isEmpty} from "lodash";
import Home from "@material-ui/icons/Home";
import {confirmAlert} from "react-confirm-alert";
import {Call_Geocode_API} from "../../constants/Utilities";
import APPCONFIG from "../../constants/Config";

const dateRangeProperties = {
	startDate: {
		error: '',
		fill: true,
		helper: '',
		label: 'Start Date',
		name: 'startDate',
		override: null,
		queryable: false,
		required: false,
		searchable: true,
	},
	endDate: {
		error: '',
		fill: true,
		helper: '',
		label: 'End Date',
		name: 'endDate',
		override: null,
		queryable: false,
		required: false,
		searchable: true,
	}
};

const timeFrameOptions = [
	{value: '1 year', label: '1 Year'},
	{value: '6 months', label: '6 Months'},
	{value: '3 months', label: '3 Months'},
	{value: '30 days', label: '30 Days'},
	{value: 'custom', label: 'Custom'}
]

const PinLocation = () => {
	return (
		<div style={{display: 'flex', width: 5, height: 5, backgroundColor: 'red', borderRadius: '50%'}} key={'pin-' + Math.random().toString()}/>);
};


const Candidate = ({color}) => {
	return (
		<div style={{zIndex: 999, textAlign: 'center', width: '100px', position: 'absolute', left: '-50px', height: '100px'}}
		     key={'cand_' + Math.random()}>
			<Person fontSize={'large'} style={{color: color}}/>
		</div>
	);
};

export default class HiringHeatmap extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Hiring_Candidate._name);

		this.state.items = [];
		this.state.coords = [];
		this.state.hiringZones = [];
		this.state.key = 0;
		this.state.addZone = false;
		this.state.regions = [];

		let requests = JSON.parse(localStorage.getItem('HiringHeatMap'));
		if (isEmptyObject(requests)) {
			requests = {}
			requests.startDate = moment().subtract(1, 'year').format('MM/DD/YYYY');
			requests.endDate = moment().format('MM/DD/YYYY');
			requests.selectedRegion = {
				pkey: 1,
				name: "Phoenix (602, 480, 623)",
				latitude: "33.4484000",
				longitude: "-112.0740000",
			};
			requests.distance = 30;
			requests.time_frame = '1 year'
			localStorage.setItem('HiringHeatMap', JSON.stringify(requests));
		}
		this.state = {
			...this.state,
			initialDate: [{'start': moment(requests.startDate).format('MM/DD/YYYY'), 'end': moment(requests.endDate).format('MM/DD/YYYY')}],
			startDate: moment(requests.startDate).format('MM/DD/YYYY'),
			endDate: moment(requests.endDate).format('MM/DD/YYYY'),
			selectedRegion: requests.selectedRegion,
			distance: requests.distance,
			time_frame: requests.time_frame,
			defaultCenter: {
				lat: parseFloat(requests.selectedRegion.latitude),
				lng: parseFloat(requests.selectedRegion.longitude)
			}
		}
	}

	async componentDidMount() {
		this.setState({loading: true, items: []})
		await this.getRegions()
		await this.getCoords()
		setTimeout(async () => {
			const startCoords = localStorage.getItem('map_coords');
			if (startCoords?.split(',')?.length > 1) {
				if (this.state.hiringZones.length === 0) {
					alert('There are no active hiring zones in this metro.')
				} else {
					await this.calculateScore(false, {lat: parseFloat(startCoords.split(',')[0]), lng: parseFloat(startCoords.split(',')[1])})
				}
			}
			localStorage.setItem('map_coords', null)
		}, 5000)
		//get zones here

	}

	apiIsLoaded = (map, maps) => {
		this.setState({map, maps})
	};

	getZones = async () => {
		//get zones here
		let zoneModel = new API.BuildClass(Types.Hiring_Zone._name, API.RequestType.READ_ALL);
		zoneModel.filter = {
			'region': this.state.selectedRegion.pkey
		}
		zoneModel = await zoneModel.submit(null, 'GET_ALL');

		if (zoneModel.items.length > 0) {
			this.state.hiringZones = zoneModel.items;
		} else {
			this.state.hiringZones = [];
		}

	}

	getCoords = async () => {
		if (this.state.zipcode) {
			await this.navtoZip()
		}
		const startCoords = localStorage.getItem('map_coords');
		if (startCoords?.split(',')?.length === 3) {
			this.state.selectedRegion = this.state.regions.find((item) => item.pkey == startCoords.split(',')[2])
		}
		const latitude = this.state.latitude ? parseFloat(this.state.latitude) : this.state.selectedRegion ? this.state.selectedRegion.latitude : 32.8208156;
		const longitude = this.state.longitude ? parseFloat(this.state.longitude) : this.state.selectedRegion ? this.state.selectedRegion.longitude : -97.2143227;
		this.setState({loading: true, items: [], cand_a_coords: null, cand_b_coords: null})
		let pkeyModel = new API.BuildClass(Types.Tickets._name, API.RequestType.READ_ALL);
		pkeyModel.filter = {
			'start': this.state.startDate,
			'end': this.state.endDate,
			'lat': latitude,
			'long': longitude,
			'region': this.state.selectedRegion.pkey
		}
		pkeyModel.limit = 5000;
		let functioning = await pkeyModel.submit(null, 'GET_HEATMAP');

		await this.getZones()

		if (this.state.map) {
			const latLng = new this.state.maps.LatLng(latitude, longitude); // Makes a latlng
			this.state.map.panTo(latLng);
			this.state.map.setZoom(9)
		}

		setTimeout(() => {
			if (this.state.map) {
				const latLng = new this.state.maps.LatLng(latitude, longitude); // Makes a latlng
				this.state.map.panTo(latLng);
				this.state.map.setZoom(9)
				this.setState({center: latLng})
			}

			const pins = functioning.items.map(
				(item, i) => {
					if (!item.long || !item.lat) {
						return null;
					} else {
						return (
							<PinLocation
								key={'pin_' + i}
								zoom={this.state.zoom}
								lat={item.lat}
								lng={item.long}
							/>

						)
					}
				}
			)

			this.setState({
				defaultCenter: {
					lat: latitude,
					lng: longitude
				},
				items: functioning.items,
				loading: false,
				itemPins: pins
			})
		}, 1500) //timeout here is to guarantee the pins are ready to be rendered


		let requests = {}
		requests.startDate = this.state.startDate;
		requests.endDate = this.state.endDate;
		requests.selectedRegion = this.state.selectedRegion;
		requests.distance = this.state.distance;
		requests.time_frame = this.state.time_frame
		localStorage.setItem('HiringHeatMap', JSON.stringify(requests));
	}

	navtoZip = async (shouldReturn = false, zipcode = null, latLng = null) => {
		let returnable;
		if (latLng) {
			returnable = latLng;
		}
		if (zipcode || this.state.zipcode) {
			const response = await Call_Geocode_API(zipcode ?? this.state.zipcode);
			if (!response || !response?.latitude) {
				API.Toast.error("Error getting geocoords for this zip.", {
					position: API.Toast.POSITION.TOP_CENTER,
					autoClose: 2000
				});
				return;
			}
			if (shouldReturn) {
				returnable = {lat: response.latitude, lng: response.longitude}
			} else {
				this.state.latitude = response.latitude
				this.state.longitude = response.longitude

				let modelRegion = new API.BuildClass(Types.Customers_Locations._name, API.RequestType.READ);
				modelRegion.filter = {
					'latitude': this.state.latitude,
					'longitude': this.state.longitude,
				}
				modelRegion.submit(null, 'GET_REGION', true)
					.then(regional => {
						if (Object.keys(regional).length > 0) {
							this.setState({selectedRegion: this.state.regions.find((item) => item.pkey === regional.regionPkey)})
						} else {
							this.setState({
								selectedRegion: {
									pkey: 1,
									name: "Phoenix (602, 480, 623)",
									latitude: "33.4484000",
									longitude: "-112.0740000"
								}
							})
							alert('No region found near that zipcode, defaulting to Phoenix.')
						}
					});
			}
		}
		if (shouldReturn) {
			if (this.state.hiringZones.length > 0) {
				let toofar = true;
				let distance = 10000;
				this.state.hiringZones.map((item) => {
					const poly = new google.maps.Polygon({paths: JSON.parse(item.coords)});
					const latLng = new this.state.maps.LatLng(returnable.lat, returnable.lng);
					if (!google.maps.geometry.poly.containsLocation(latLng, poly)) {
						//not inside a poly, should check if it's close
						for (var leg of poly.getPath().g) {
							// if (google.maps.geometry.spherical.computeDistanceBetween(latLng,leg) <= 72420.5){
							// 	toofar = false;
							// } else {
							// 	const diff = (google.maps.geometry.spherical.computeDistanceBetween(latLng,leg) - 72420.5)/1609;
							// 	if ((Math.round(diff*100)/100) < distance) {
							// 		distance = (Math.round(diff*100)/100)
							// 		console.log(distance)
							// 	}
							// }
							const diff = google.maps.geometry.spherical.computeDistanceBetween(latLng, leg) / 1609;
							if ((Math.round(diff * 100) / 100) < distance) {
								distance = (Math.round(diff * 100) / 100)
							}
						}
					} else {
						toofar = false;
					}
				})
				if (toofar) {
					returnable.distance = distance
				}
			}
			return returnable;
		}
	}

	getRegions = async () => {
		let model = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		model.limit = 5000;
		try {
			this.regions = await model.submit(null, this.read);
			this.regions = Object.keys(this.regions).map((key) => this.regions[key]);
			this.regions = this.regions[3];
			this.regions = this.regions.sort(function (a, b) {
				return a.name.localeCompare(b.name)
			})
			this.regions = this.regions.filter((region) => {
				return region.latitude > 0 || region.latitude < 0
			})
			this.setState({
				regions: this.regions,
				selectedRegion: this.regions.find((item) => item.pkey === this.state.selectedRegion.pkey)
			});
		} catch (error) {
		}
	}

	handleDateChange = (property, value) => {
		let {startDate, endDate} = this.state;
		let _startDate = moment(startDate);
		let _endDate = moment(endDate);
		let _value = moment(value);
		if (property === 'startDate') {
			if (_value.isAfter(_endDate)) {
				alert('Start date may not be after end date.')
				return;
			}
		}
		if (property === 'endDate') {
			if (_value.isBefore(_startDate)) {
				alert('End date may not be before start date.')
				return;
			}
		}
		this.state.initialDate = null;
		this.handleTextFieldPropertyUpdate(property, moment(value).format('MM/DD/YYYY'));
	}

	handleTimeFrame = async ({value, label}) => {
		if (value !== 'custom') {
			this.state.startDate = moment().subtract(parseInt(value.split(' ')[0]), value.split(' ')[1]).format('MM/DD/YYYY')
			this.state.endDate = moment().format('MM/DD/YYYY')
		}

		this.setState({time_frame: value})
	}

	rad2deg(radians) {
		return (radians * (180 / Math.PI))
	}

	deg2rad(degrees) {
		return (degrees * (Math.PI / 180))
	}

	generateScore = async (lat, lng) => {
		const earthRadius = 3959;
		const distance = this.state.distance;
		const maxLat = lat + this.rad2deg(distance / earthRadius)
		const minLat = lat - this.rad2deg(distance / earthRadius)
		const maxLon = lng + this.rad2deg(Math.asin(distance / earthRadius) / Math.cos(this.deg2rad(lat)))
		const minLon = lng - this.rad2deg(Math.asin(distance / earthRadius) / Math.cos(this.deg2rad(lat)))
		const within = this.state.items.filter((item) => {
			return ((item.lat >= minLat && item.lat <= maxLat) && (item.long >= minLon && item.long <= maxLon))
		})

		return Math.floor((within.length / this.state.items.length) * 100);
	}

	calculateScore = async (ignore_alert = false, latlng = null) => {
		let cand = await this.navtoZip(true, this.state.zipcode ?? null, latlng)
		if (this.state.hiringZones.length === 0) {
			alert('There are no active hiring zones in this metro.')
			return;
		}
		//calculate score here
		let score = 0;
		if (this.state.items.length > 0) {
			score = await this.generateScore(cand.lat, cand.lng);
		}

		this.setState({cand_a_coords: {lat: cand.lat, lng: cand.lng, score: score}})
		if (cand.distance && !ignore_alert) {
			alert('Candidate is at least ' + cand.distance + ' miles outside of the nearest hiring zone.')
		}
	}

	formatOptionLabel = ({label, showRedDot}) => {
		return (
			<div style={{ display: 'flex', alignItems: 'center' }}>
				{label}
				{showRedDot && <span style={{ color: 'red', marginLeft: 8 }}>• Hiring</span>}
			</div>
		)
	};

	render() {
		let zoom = 9;
		let extras = {};

		let {properties} = this.model

		let object = this.state;

		return (
			<Card>
				<CardContent>
					<div>
						<div className={"table-bar"}>
							<div className={'row'}>
								<div className={'col-3'} style={{display: 'flex', flexDirection: 'column'}}>
									<Select
										key={this.state.regions}
										placeholder={"Region Select"}
										value={{value: this.state.selectedRegion.pkey, label: this.state.selectedRegion.name, showRedDot: this.state.selectedRegion.active_zone === 'true'}}
										onChange={(value) => {
											console.log('VALUE', value)
											this.setState({
												selectedRegion: this.state.regions.find((region) => region.pkey === value.value),
												latitude: null,
												longitude: null,
												zipcode: ''
											})
										}}
										formatOptionLabel={this.formatOptionLabel}
										options={this.state.regions?.map(region => {
											return (
												{value: region.pkey, label: region.name, showRedDot: region.active_zone === 'true'}
											)
										})}
										styles={{
											singleValue: (provided, state) => ({
												...provided,
												display: 'flex',
												alignItems: 'center'
											}),
											option: (provided, state) => ({
												...provided,
												display: 'flex',
												alignItems: 'center'
											})
										}}

									/>
									<div style={{display: 'flex', flexDirection: 'row', paddingTop: 5, justifyContent: "space-between"}}>
										<div style={{display: 'flex', flexDirection: 'row'}}>
											<b style={{display: 'flex', alignItems: 'center', paddingRight: 5}}>Score Zipcode</b>
											<input name={'map_zipcode'} id={'map_zipcode'} type={'text'} maxLength={5} style={{width: 75}}
											       onChange={(event) => this.setState({zipcode: event.currentTarget.value})} value={this.state.zipcode}/>
										</div>

										<Button color={'info'} size={'sm'}
										        disabled={this.state.items.length === 0 || !this.state.zipcode} onClick={async () => {

											if (this.state.zipcode.length < 5) {
												alert('Please input a full zipcode.')
												return;
											}

											await this.calculateScore();

											//
											//
											// //check candidate a
											// if (this.state.cand_a_zipcode) {
											// 	if (this.state.cand_a_zipcode.length < 5) {
											// 		alert('Please input a full zip code for Candidate A.')
											// 		return;
											// 	}
											// 	let cand_a = await this.navtoZip(true, this.state.cand_a_zipcode)
											// 	//calculate score here
											// 	let score = 0;
											// 	if (this.state.items.length > 0) {
											// 		score = await this.generateScore(cand_a.lat, cand_a.lng);
											// 	}
											//
											// 	this.setState({cand_a_coords: {lat: cand_a.lat, lng: cand_a.lng, score: score}})
											// 	if (cand_a.distance) {
											// 		alert('Candidate A is at least ' + cand_a.distance + ' miles outside of the nearest hiring zone.')
											// 	}
											// } else {
											// 	this.setState({cand_a_coords: null})
											// }
											//
											// //check candidate b
											// if (this.state.cand_b_zipcode) {
											// 	if (this.state.cand_b_zipcode.length < 5) {
											// 		alert('Please input a full zip code for Candidate B.')
											// 		return;
											// 	}
											// 	let cand_b = await this.navtoZip(true, this.state.cand_b_zipcode)
											// 	//calculate score here
											// 	let score = 0;
											// 	if (this.state.items.length > 0) {
											// 		score = await this.generateScore(cand_b.lat, cand_b.lng);
											//
											// 	}
											// 	this.setState({cand_b_coords: {lat: cand_b.lat, lng: cand_b.lng, score: score}})
											// 	if (cand_b.distance) {
											// 		alert('Candidate B is at least ' + cand_b.distance + ' miles outside of the nearest hiring zone.')
											// 	}
											// } else {
											// 	this.setState({cand_b_coords: null})
											// }
										}}>Calculate Score</Button>
									</div>
									{/*<div style={{display: 'flex', flexDirection: 'row', paddingTop: 5}}>*/}
									{/*	<b style={{display: 'flex', alignItems: 'center', paddingRight: 5, color: '#355E3B'}}>Cand. A Zipcode</b>*/}
									{/*	<input name={'map_zipcode'} id={'map_zipcode'} type={'text'} maxLength={5} style={{width: 75}}*/}
									{/*	       onChange={(event) => {*/}
									{/*			   this.setState({cand_a_zipcode: event.currentTarget.value})*/}
									{/*		       if (event.currentTarget.value === '') {*/}
									{/*				   this.setState({cand_a_coords: null})*/}
									{/*		       }*/}
									{/*	       }} value={this.state.cand_a_zipcode}/>*/}

									{/*	<b style={{display: 'flex', alignItems: 'center', paddingRight: 5, paddingLeft: 5, color: '#0000FF'}}>Cand. B Zipcode</b>*/}
									{/*	<input name={'map_zipcode'} id={'map_zipcode'} type={'text'} maxLength={5} style={{width: 75}} disabled={this.state.cand_a_zipcode?.length !== 5}*/}
									{/*	       onChange={(event) => {*/}
									{/*			   this.setState({cand_b_zipcode: event.currentTarget.value})*/}
									{/*		       if (event.currentTarget.value === '') {*/}
									{/*				   this.setState({cand_b_coords: null})*/}
									{/*		       }*/}
									{/*	       }} value={this.state.cand_b_zipcode}/>*/}
									{/*</div>*/}
									{this.state.cand_a_coords &&
										<div style={{display: 'flex', flexDirection: 'row', paddingTop: 5, justifyContent: "space-between"}}>
											<b style={{display: 'flex', alignItems: 'center', paddingRight: 5, color: '#355E3B'}}>Score: {this.state.cand_a_coords.score ?? 'N/A'}%</b>

											{/*<b style={{display: 'flex', alignItems: 'center', paddingRight: 5, paddingLeft: 5, color: '#0000FF'}}>Cand. B Score: {this.state.cand_b_coords?.score ?? '0'}%</b>*/}

										</div>}
								</div>
								<div className={"col-1"}>
									<div style={{display: 'flex', flexDirection: 'column'}}>
										<Select
											placeholder={"Time Frame"}
											onChange={this.handleTimeFrame}
											options={timeFrameOptions}
											value={timeFrameOptions.filter((item) => item.value === this.state.time_frame)[0]}
										/>
									</div>
								</div>
								<div className={'col-3'}>
									{this.state.time_frame === 'custom' &&
										<div className="row dateRangeSearch">
											<div className="col-sm">
												<Paper>
													<Framework.Elements.Date
														label="Start Date"
														property={dateRangeProperties.startDate}
														value={moment(this.state.startDate).format('MM/DD/YYYY')}
														update={this.handleDateChange}
														disabled={false}
													/>
												</Paper>
											</div>
											<div className="col-sm">
												<Paper>
													<Framework.Elements.Date
														label="End Date"
														property={dateRangeProperties.endDate}
														value={moment(this.state.endDate).format('MM/DD/YYYY')}
														update={this.handleDateChange}
														disabled={false}
													/>
												</Paper>
											</div>
										</div>}
								</div>
								<div className={'col-3'} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '5px'}}>
									<Slider
										defaultValue={this.state.distance}
										step={5}
										marks
										min={20}
										max={60}
										valueLabelDisplay={'on'}
										value={this.state.distance}
										onChange={async (event, value) => {
											if (value !== this.state.distance) {
												this.setState({distance: value})
												if ((this.state.zipcode && this.state.zipcode.length > 4) || (this.state.cand_a_coords.lat && this.state.cand_a_coords.lng)) {
													await this.calculateScore(true, this.state.cand_a_coords)
												}
											}
										}}
									/>
									<b style={{fontSize: 20}}>Distance</b>
								</div>
									<div className={'col-1 text-right'}>
										<Button color={'primary'} size={'sm'} onClick={async () => {
											this.setState({modalCandidateAdd: true})
										}}>Add Candidate</Button>
									</div>
								<div className={'col-1 text-right'}>
									<Button color={'primary'} size={'sm'} onClick={async () => {
										this.setState({loading: true, items: []})
										await this.getCoords()
									}}>Generate Map</Button>
								</div>
							</div>
						</div>
						<div style={{height: '78vh', width: '100%'}}>
							<GoogleMapReact
								bootstrapURLKeys={{
									key: APPCONFIG.settings.GOOGLE_MAPS_API_KEY(),
									libraries: ['places'],
								}}
								defaultCenter={object.defaultCenter}
								defaultZoom={zoom}
								yesIWantToUseGoogleMapApiInternals
								onGoogleApiLoaded={({map, maps}) => this.apiIsLoaded(map, maps)}
								ref={(ref) => {
									this.mapRef = ref;
								}}
								onClick={(obj) => {
									if (this.state.addZone) {
										const found = this.state.coords.filter((item) => {
											if (item.lat === obj.lat && item.lng === obj.lng) {
												return true;
											}
										})
										if (found.length === 0) {
											this.setState({coords: [...this.state.coords, {lat: obj.lat, lng: obj.lng}]})
										}
									}
								}}
								{...extras}
							>
								{object.loading && <Framework.Elements.LoadingSpinner isLoading={object.loading}/>}
								{/*{object.center && <Circle*/}
								{/*	key={'circle'}*/}
								{/*	center={object.center}*/}
								{/*	radius={object.distance * 1609.34}*/}
								{/*	options={{*/}
								{/*		map: this.state.map,*/}
								{/*		strokeColor: 'yellow',*/}
								{/*		strokeWeight: 4,*/}
								{/*		fillOpacity: 0*/}
								{/*	}}*/}
								{/*	visible={true}*/}
								{/*	draggable={false}*/}
								{/*	onClick={(obj) => {*/}
								{/*		if (this.state.addZone) {*/}
								{/*			const found = this.state.coords.filter((item) => {*/}
								{/*				if (item.lat === obj.latLng.lat() && item.lng === obj.latLng.lng()) {*/}
								{/*					return true;*/}
								{/*				}*/}
								{/*			})*/}
								{/*			if (found.length === 0) {*/}
								{/*				this.setState({coords: [...this.state.coords, {lat: obj.latLng.lat(), lng: obj.latLng.lng()}]})*/}
								{/*			}*/}
								{/*		}*/}
								{/*	}}*/}
								{/*/>}*/}

								{object.itemPins}

								{object.coords.length > 0 &&
									<Polygon
										key={'poly'}
										options={{
											paths: this.state.coords,
											strokeColor: "#0000FF",
											strokeOpacity: 0.8,
											map: this.state.map
										}}
									/>
								}

								{object.hiringZones.map((item) => {
									return (
										<Polygon
											key={'poly'}
											options={{
												paths: JSON.parse(item.coords),
												strokeColor: this.state.zoneId === item.pkey ? "#0000FF" : "#FF0000",
												strokeOpacity: 0.8,
												map: this.state.map,
												zIndex: 999
											}}
											onClick={() => {
												if (this.state.zoneSelected) {
													this.setState({zoneId: null, zoneSelected: false})
												} else if (!this.state.addZone) {
													this.setState({zoneId: item.pkey, zoneSelected: true})
												}
											}}
										/>
									)
								})}

								{this.state.cand_a_coords && <Candidate
									key={Math.random()}
									zoom={zoom}
									lat={this.state.cand_a_coords.lat}
									lng={this.state.cand_a_coords.lng}
									color={'#355E3B'}
								/>}

								{this.state.cand_a_coords && <Circle
									key={'circle_canda' + Math.random()}
									center={new google.maps.LatLng(this.state.cand_a_coords.lat, this.state.cand_a_coords.lng)}
									radius={this.state.distance * 1609.34}
									options={{
										map: this.state.map,
										strokeColor: '#355E3B',
										strokeWeight: 4,
										fillOpacity: 0,
										zIndex: 1
									}}
									visible={true}
									draggable={false}
								/>}

								{/*{this.state.cand_b_coords && <Candidate*/}
								{/*	key={Math.random()}*/}
								{/*	zoom={zoom}*/}
								{/*	lat={this.state.cand_b_coords.lat}*/}
								{/*	lng={this.state.cand_b_coords.lng}*/}
								{/*	color={'#0000FF'}*/}
								{/*/>}*/}

								{/*{this.state.cand_b_coords && <Circle*/}
								{/*	key={'circle_candb' + Math.random()}*/}
								{/*	center={new google.maps.LatLng(this.state.cand_b_coords.lat, this.state.cand_b_coords.lng)}*/}
								{/*	radius={35 * 1609.34}*/}
								{/*	options={{*/}
								{/*		map: this.state.map,*/}
								{/*		strokeColor: '#0000FF',*/}
								{/*		strokeWeight: 4,*/}
								{/*		fillOpacity: 0,*/}
								{/*		zIndex: 1*/}
								{/*	}}*/}
								{/*	visible={true}*/}
								{/*	draggable={false}*/}
								{/*/>}*/}
							</GoogleMapReact>
						</div>
					</div>

					<Framework.Elements.UniversalModal
						key={this.state.modalKey}
						regions={this.props.regions}
						name={"Candidate"}
						object={Objects.Candidate}
						history={this.props.history}
						toggle={this.state.modalCandidateAdd}
						reportClose={() => this.setState({modalCandidateAdd: false})}
						//afterSave={async () => await this.getCoords()}
						objectProps={{
							roles: this.props.roles,
							/*cacheInfo: async (state, props) => {
								if (!state.latitude || !state.longitude) {
									alert("There was an issue with that candidate's latitude and longitude. Please make sure their address is correct.")
								}
								let cand = await this.navtoZip(true, null, {lat: state.latitude, lng: state.longitude})
								if (cand.distance) {
									confirmAlert({
										title: 'Candidate Too Far',
										message: 'This candidate is at least ' + cand.distance + ' miles away from a hiring zone. Are you sure you want to add this candidate?',
										buttons: [
											{
												label: 'Yes',
												onClick: async () => {
													//send confirm that they ignored
													state.ignored = true;
													this.setState({cachedInfo: state})
												}
											},
											{
												label: 'No',
												onClick: async () => {
													//close modal here?
													await props.toggleClose();
												}
											}
										]
									});
								}

							},
							cachedInfo: this.state.cachedInfo ?? null*/
						}}
					/>
				</CardContent>
			</Card>
		)
	}
}
